var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"dropdown-label-box gl-flex-shrink-0 gl-top-0 gl-mr-3",style:({ 'background-color': _vm.label.color }),attrs:{"data-testid":"label-color-box"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }